import { Button, InputField } from '@hakimo-ui/shared/ui-base';
import {
  FunnelIcon,
  Squares2X2Icon,
  TableCellsIcon,
} from '@heroicons/react/24/outline';

interface Props {
  searchValue: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  hasFiltersApplied: boolean;
  onClickFilter: () => void;
  viewMode: 'grid' | 'list';
  onViewModeChange: (mode: 'grid' | 'list') => void;
}

function TenantsHeader(props: Props) {
  const {
    searchValue,
    onSearchChange,
    hasFiltersApplied,
    onClickFilter,
    viewMode,
    onViewModeChange,
  } = props;

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="max-w-md flex-1">
        <InputField
          label=""
          value={searchValue}
          onChange={onSearchChange}
          type="search"
          placeholder="Search by name..."
        />
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="icon"
          badge={hasFiltersApplied}
          onClick={onClickFilter}
          title="Open filters"
        >
          <span className="sr-only">Open filters panel</span>
          <FunnelIcon className="h-5 w-5" aria-hidden="true" />
        </Button>
        <Button
          variant="icon"
          onClick={() =>
            onViewModeChange(viewMode === 'grid' ? 'list' : 'grid')
          }
          title={
            viewMode === 'grid' ? 'Switch to table view' : 'Switch to grid view'
          }
        >
          <span className="sr-only">Toggle view mode</span>
          {viewMode === 'grid' ? (
            <TableCellsIcon className="h-5 w-5" aria-hidden="true" />
          ) : (
            <Squares2X2Icon className="h-5 w-5" aria-hidden="true" />
          )}
        </Button>
      </div>
    </div>
  );
}

export default TenantsHeader;
